(function () {
  'use strict';

  angular
    .module('app.address-book', []);
  
})();